import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'g-detail-pop',
  props: {
  isShowPlateDetails: {
    type: Boolean,
    default: false,
  },
  fullName: {
    type: String,
    default: '',
  },
  currentIndex: {
    type: Number,
    default: 0,
  },
  sourceList: {
    type: Array,
    default: () => [],
  },
  idPrefix: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: 'materialPage.overSize.nonWorkInfo',
  },
  popStyle: {
    type: Object,
    default: () => {},
  },
},
  emits: [
  'update:isShowPlateDetails',
  'clickOperate',
  'clickGoBack',
],
  setup(__props, { emit: emits }) {

const props = __props

let isShowAllText = ref(false)


let isShowPlateDetails = computed({
  get: () => props.isShowPlateDetails,
  set: (value) => emits('update:isShowPlateDetails', value),
})
// 查看上一个/下一个
function handleOperate(operate: string) {
  // 调用父组件的方法
  emits('clickOperate', operate)
}
// 返回上级页面
function handleGoBack() {
  emits('clickGoBack')
}

return { __sfc: true,isShowAllText, props, emits, isShowPlateDetails, handleOperate, handleGoBack }
}

})